/**
 * @file Entrypoint for the `@openshift-console/dynamic-plugin-sdk` package published to npmjs.
 *
 * Provides core APIs, types and utilities used by dynamic plugins at runtime.
 */

export * from './extensions';
export * from './api/core-api';
